import './App.scss';
import 'swiper/swiper.scss';
import 'swiper/components/effect-fade/effect-fade.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import './styles/icons.css';
import Home from './pages/Index'
import Promo from './pages/Promo'
import Layout from './Layout';
import {
  Switch,
  Route,
  HashRouter
} from "react-router-dom"
import ScrollToTop from './helper/ScrollToTop';


function App() {
  return (
    <HashRouter>
      <ScrollToTop>
        <Switch>
          <Layout>
            <Route exact path="/promo/:slug" component={Promo} />
            <Route exact path="/" component={Home} />
          </Layout>
        </Switch>
      </ScrollToTop>
    </HashRouter>
  );
}

export default App;
